export default {
	zoomOauthError: "Zoom OAuth error. Please try again.",
	zoomOauthSuccess: "Zoom OAuth success. Please wait while we redirect you.",
};
